// 9fbef606107a605d69c0edbcd8029e5d
import { connect } from 'react-redux';
import {
  getIsBopisEnabled,
  getIsBopisPromotionDiscountEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import {
  getDefaultBopisPromotionDiscountValue,
  getOfferTypeBasedPromotion,
} from './BopisPromotionBanner.selector';
import BopisPromotionBanner from '../views/BopisPromotionBanner.view';
import { getStoreSpecialList } from '../../../organisms/PickupStoreModal/container/PickUpStoreModal.selectors';

export const mapStateToProps = (state) => {
  return {
    isBopisEnabled: getIsBopisEnabled(state),
    isBopisPromoDiscountBannerEnabled: getIsBopisPromotionDiscountEnabled(state),
    defaultBopisPromotionDiscountValue: getDefaultBopisPromotionDiscountValue(state),
    offerTypeBasedPromotion: getOfferTypeBasedPromotion(state),
    storeSpecialList: getStoreSpecialList(state),
  };
};

export default connect(mapStateToProps)(BopisPromotionBanner);
